export const TAB_VIEW_KANBAN = "kanban";
export const TAB_VIEW_LIST = "list";
export const TAB_VIEW_BEST_FIT = "best-fit";
export const TAB_VIEW_TIMELINE = "timeline";

export const DEFAULT_STAGE_COLOR = "#E5E7EB";

export const PROPOSAL_OUTLINE_COMPLETED = "COMPLETED";

export const PROPOSAL_OUTLINE_STAGES = {
  PENDING: "PENDING",
  IN_PROGRESS: "IN_PROGRESS",
  [PROPOSAL_OUTLINE_COMPLETED]: PROPOSAL_OUTLINE_COMPLETED,
  AWAITING_CLARIFICATION: "AWAITING_CLARIFICATION",
  CLASSIFYING: "CLASSIFYING",
  AWAITING_TYPE_REVIEW: "AWAITING_TYPE_REVIEW",
  EXTRACTING: "EXTRACTING",
  AWAITING_REQ_REVIEW: "AWAITING_REQ_REVIEW",
  GENERATING: "GENERATING",
  FAILED: "FAILED",
};

export const IN_PROGRESS_STATUSES = new Set([
  PROPOSAL_OUTLINE_STAGES.PENDING,
  PROPOSAL_OUTLINE_STAGES.IN_PROGRESS,
  PROPOSAL_OUTLINE_STAGES.CLASSIFYING,
  PROPOSAL_OUTLINE_STAGES.EXTRACTING,
  PROPOSAL_OUTLINE_STAGES.GENERATING,
]);

export const DETACHED_PREFIX = "DETACHED - ";

export const EXISTING_DOCUMENT_ACTION = {
  DELETE: "DELETE",
  DETACH_AND_RENAME: "DETACH_AND_RENAME",
};

export const REQUIREMENT_VERIFICATION = {
  VERIFIED: "VERIFIED",
  FUZZY_MATCH: "FUZZY_MATCH",
  UNVERIFIED: "UNVERIFIED",
  USER_PROVIDED: "USER_PROVIDED",
};

export const REQUIREMENT_ORIGIN = {
  EXTRACTED: "EXTRACTED",
  USER_EDITED: "USER_EDITED",
  USER_ADDED: "USER_ADDED",
};

export const REQUIREMENT_STATUS = {
  ACTIVE: "ACTIVE",
  REMOVED: "REMOVED",
};

export const OUTLINE_SECTION_STATUS = {
  NOT_STARTED: "NOT_STARTED",
  DRAFTING: "DRAFTING",
  IN_REVIEW: "IN_REVIEW",
  COMPLETE: "COMPLETE",
};

export const OUTLINE_SECTION_STATUS_LABELS = {
  [OUTLINE_SECTION_STATUS.NOT_STARTED]: "Not Started",
  [OUTLINE_SECTION_STATUS.DRAFTING]: "Drafting",
  [OUTLINE_SECTION_STATUS.IN_REVIEW]: "In Review",
  [OUTLINE_SECTION_STATUS.COMPLETE]: "Complete",
};

export const GATE_URL_SEGMENT = {
  TYPE_REVIEW: "type-review",
  REQ_REVIEW: "req-review",
};

export const SOFT_GATE = "SOFT_GATE";
export const HARD_GATE = "HARD_GATE";
export const NO_GATE = "NO_GATE";

export const DEFAULT_GATE_MODE = SOFT_GATE;

export const QUESTION_TYPE = {
  YES_NO: "YES_NO",
  MULTIPLE_CHOICE: "MULTIPLE_CHOICE",
  FREE_TEXT: "FREE_TEXT",
};

export const YES_NO_VALUES = { YES: "Yes", NO: "No" };

export const GATE_ERROR_CODE = {
  GATE_INCOMPLETE: "GATE_INCOMPLETE",
  SKIP_NOT_ALLOWED: "SKIP_NOT_ALLOWED",
  INVALID_ANSWER: "INVALID_ANSWER",
  GATE_CONFIG_CHANGED: "GATE_CONFIG_CHANGED",
};

const GATE_ORDINALS = [
  "First",
  "Second",
  "Third",
  "Fourth",
  "Fifth",
  "Sixth",
  "Seventh",
  "Eighth",
  "Ninth",
  "Tenth",
];

export const getOrdinalLabel = (index) =>
  GATE_ORDINALS[index] ?? `${index + 1}th`;
